/* Standard Google events are owned by the installed Google & YouTube app pixel.
 * The theme loads Shopify's consent API for the knife-finder consent check.
 * No second gtag loader or Ads config is injected here.
 */
(() => {
  if (window.Shopify?.customerPrivacy) return;
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
})();
